import { Injectable, Inject } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { ConfirmPrompt } from '../services/confirm-prompt';
import { makeNavigationCancellingError } from '../lib/utils';

export const cantActivateReasonConfirmPromptGuard: string = 'promptVisible';

@Injectable()
export class ConfirmPromptGuard implements CanActivateChild, CanActivate {
  constructor(@Inject(ConfirmPrompt) private confirmPrompt) {}

  public canActivate(): boolean {
    if (!this.promptGuard()) throw makeNavigationCancellingError(cantActivateReasonConfirmPromptGuard);
    return true;
  }

  public canActivateChild(): boolean {
    if (!this.promptGuard()) throw makeNavigationCancellingError(cantActivateReasonConfirmPromptGuard);
    return true;
  }

  private promptGuard(): boolean {
    return this.confirmPrompt.isPromptHidden();
  }
}
